import React, { useEffect } from "react";
import { Wrapper } from "../../constants/common/StyledGlobalConstants";
import CPNotification from "../../pages/Login/CPNotification";
import { InvoiceTextLink, Spacer } from "./QuickBillSummary";
import { AUTOPAY_CONSTANTS } from "../../constants/StringConstants";
import { pendoTrack } from "../../util/pendoUtil";
import PropTypes from "prop-types";

const AutoPay = ({ t, isAutoPayEnabled, makePayment, invoiceNumber, restoredAccount, contractAccountId }) => {
  useEffect(() => {
    let eventName = "";
    let status = "";

    if (restoredAccount && isAutoPayEnabled) {
      eventName = "Customer Portal | Billing And Payment | Reactivated Account - AutoPay | Payments In Order";
      status = "AutoPay is enabled, and payments are in order.";
    } else if (restoredAccount && !isAutoPayEnabled) {
      eventName = "Customer Portal | Billing And Payment | Reactivated Account - AutoPay | Payments In Order Without AutoPay";
      status = "Payments are in order, but AutoPay is not enabled.";
    } else if (!restoredAccount) {
      eventName = "Customer Portal | Billing And Payment | AutoPay | Not Using AutoPay";
      status = "User is not currently using AutoPay.";
    }

    if (eventName) {
      pendoTrack(eventName, {
        Status: status,
        ContractAccountID: contractAccountId,
      });
    }
  }, [restoredAccount, isAutoPayEnabled, contractAccountId]);

  const getNotificationContent = () => {
    if (restoredAccount && isAutoPayEnabled) {
      return t(AUTOPAY_CONSTANTS.ACCOUNT_PAYMENTS_IN_ORDER);
    }

    if (restoredAccount && !isAutoPayEnabled) {
      return (
        <>
          {t(AUTOPAY_CONSTANTS.ACCOUNT_PAYMENTS_IN_ORDER_WITH_AUTOPAY)}
          <InvoiceTextLink
            style={{ width: "fit-content", cursor: "pointer", borderColor: "#000000", color: "#000000" }}
            id="manage-payment-methods-blueBanner"
            size="small"
            type="standAlone"
            role="link"
            aria-label={t(AUTOPAY_CONSTANTS.MANAGE_PAYMENT_METHODS)}
            tabIndex="0"
            onClick={() => makePayment("managewallet", invoiceNumber)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") makePayment("managewallet", invoiceNumber);
            }}
          >
            {t(AUTOPAY_CONSTANTS.MANAGE_PAYMENT_METHODS)}
          </InvoiceTextLink>
          .
        </>
      );
    }

    return (
      <>
        {t("You are not currently using Auto Pay.")}{" "}
        <InvoiceTextLink
          style={{ width: "fit-content", cursor: "pointer", borderColor: "#000000", color: "#000000" }}
          id="sign-up-now-autopay"
          size="small"
          type="standAlone"
          role="link"
          aria-label="Sign up now"
          tabIndex="0"
          onClick={() => makePayment("managewallet", invoiceNumber)}
        >
          {t("Sign up now")}
        </InvoiceTextLink>{" "}
        {t("and have your invoice paid automatically each month.")}
      </>
    );
  };

  return (
    <Wrapper marginTop="2rem" marginBottom="24px">
      <Spacer bottom="8px">
        <CPNotification
          id="blue-banner-notification"
          isOpen={true}
          notificationType="info"
          restoredAccount={restoredAccount} // Pass restoredAccount to CPNotification
          height="auto"
          width="100%"
          closeButton={false}
          aria-live="polite"
        >
          <Wrapper fontFamily="Neue Haas Grotesk Text Std" fontSize="0.875rem">
            {getNotificationContent()}
          </Wrapper>
        </CPNotification>
      </Spacer>
    </Wrapper>
  );
};
AutoPay.propTypes = {
  t: PropTypes.func.isRequired,
  isAutoPayEnabled: PropTypes.bool,
  makePayment: PropTypes.func,
  invoiceNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  restoredAccount: PropTypes.bool,
  contractAccountId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default AutoPay;
